<template>
    <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
        <HeaderToolbar/>
        <div class="post d-flex flex-column-fluid" id="kt_post">
            <div id="kt_content_container" class="container-fluid">
                <slot />
            </div>
        </div>
    </div>
</template>
<script>
import HeaderToolbar from "./HeaderToolbar";

export default {
    components: {HeaderToolbar}
}
</script>
